import { __assign, __rest } from "tslib";
import React from 'react';
import VeltSubtitlesPanelWireframe from '../VeltSubtitlesPanelWireframe/VeltSubtitlesPanelWireframe';
import VeltSubtitlesButtonWireframe from '../VeltSubtitlesButtonWireframe/VeltSubtitlesButtonWireframe';
import VeltSubtitlesTooltipWireframe from '../VeltSubtitlesTooltipWireframe/VeltSubtitlesTooltipWireframe';
import VeltSubtitlesCloseButtonWireframe from '../VeltSubtitlesCloseButtonWireframe/VeltSubtitlesCloseButtonWireframe';
import VeltSubtitlesTextWireframe from '../VeltSubtitlesTextWireframe/VeltSubtitlesTextWireframe';
import { transformWireframeProps } from '../../../utils/propUtils';
var VeltSubtitlesFloatingModeWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-subtitles-floating-mode-wireframe", __assign({}, transformedProps), children));
};
VeltSubtitlesFloatingModeWireframe.Button = VeltSubtitlesButtonWireframe;
VeltSubtitlesFloatingModeWireframe.Tooltip = VeltSubtitlesTooltipWireframe;
VeltSubtitlesFloatingModeWireframe.Panel = VeltSubtitlesPanelWireframe;
VeltSubtitlesFloatingModeWireframe.CloseButton = VeltSubtitlesCloseButtonWireframe;
VeltSubtitlesFloatingModeWireframe.Text = VeltSubtitlesTextWireframe;
export default VeltSubtitlesFloatingModeWireframe;
